<template>
  <div class="sitelist">
    <GlobTopNav title="收货地址管理"></GlobTopNav>

    <!--地址-->
    <div style="padding-bottom: 0.9rem" class="van-content">
      <div class="nodata text-cent" v-if="nodata && datas == ''">
        <img src="./../../../assets/img/address-null.png" />
        <span class="text">还没有添加地址~</span>
      </div>
      <van-swipe-cell
        :right-width="60"
        :left-width="0"
        v-if="datas != ''"
        v-for="(items, index) in datas"
        :key="items.id"
      >
        <span slot="left">选择</span>
        <van-cell-group>
          <div class="van-cell">
            <div class="sitebox">
              <div class="sitebox-user">
                <div class="van-address-list__name">
                  <span class="van-address-list__name-all">
                    {{ items.name }}&#8194;<span class="float-right">{{ items.phone }}</span>
                    <span class="sitebox-mr" v-if="items.default == 1">默认</span>
                  </span>

                  <div class="text-right site-btnbox">
                    <!--<span v-if="items.moren == 0">设为默认</span>-->
                    <div
                      data-v-8976be6e=""
                      class="float-left van-checkbox"
                      @click="morenPlay(items.id, index, items.default)"
                    >
                      <!-- <i
                    style="text-align: center; border-radius: 50%; width: .2rem"
                    class="van-icon van-icon-success van-checkbox__icon van-checkbox--round"
                    :class="{ 'van-checkbox--checked': items.default == 1 }"
                  ></i>
                  <span class="van-checkbox__label">{{
                    items.default == 1 ? '默认地址' : '设为默认'
                  }}</span> -->
                    </div>
                    <router-link
                      tag="span"
                      :to="{ path: '/user/mysite/amendsite', query: { id: items.id } }"
                    >
                      <img class="icon-size" src="./../../../assets/img/dz-bj.png" alt="" />
                    </router-link>
                    <span @click="removeSite(items.id, index)">
                      <img class="icon-size" src="./../../../assets/img/dz-sc.png" alt="" />
                    </span>
                  </div>
                </div>
                <div class="van-address-list__address site-address">
                  {{ items.province_str }}{{ items.city_str }}{{ items.county_str
                  }}{{ items.town_str }}{{ items.address }}
                </div>
              </div>
            </div>
          </div>
        </van-cell-group>
        <span slot="right">
          <button class="clearbtn theme-bd theme-bg" @click="removeSite(items.id, index)">
            删除
          </button>
        </span>
      </van-swipe-cell>
      <!--<van-address-list v-model="chosenAddressId"  @edit="amendSite" :list="siteList" v-if="siteList[0].id != ''">
      </van-address-list>-->
      <van-cell-group v-else>
        <van-cell>添加收货地址</van-cell>
      </van-cell-group>
    </div>
    <div class="addSiteBtn">
      <!--<router-link to="/user/mysite/addsite"><van-button style="font-size: .16rem" class="theme-bd theme-bg">添加收货地址</van-button></router-link>-->
      <van-button @click="addsites()" class="add theme-bd theme-bg"> +新增收货地址 </van-button>
    </div>
  </div>
</template>

<script>
import TopNav from "@/components/topnav";
export default {
  name: "mysite",
  components: {
    TopNav
  },
  data() {
    return {
      datas: "",
      nodata: false,
      checked: "",
      length: 0,
      siteList: [
        {
          id: "",
          name: "",
          tel: "",
          address: ""
        }
      ]
    };
  },
  methods: {
    amendSite: function(item, index) {
      this.$router.push({
        path: "/user/mysite/amendsite",
        query: { id: item.id }
      });
    },
    goBack: function() {
      history.back(-1);
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    addsites: function() {
      this.$router.push({ path: "/user/mysite/addsite" });
      // if (this.length < 5) {
        
      // } else {
      //   this.$toast("最多保存5条收货信息");
      // }
    },
    removeSite: function(id, index) {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定要删除此收货地址吗？"
        })
        .then(() => {
          var isUser = localStorage.getItem("BLHuser");
          this.$api.post(
            "user/address/delete",
            { id_example: mallid, token_user: isUser, id_address: id },
            res => {
              if (res.data.code == "100") {
                this.datas.splice(index, 1);
                this.getDatas();
              } else {
                this.$toast({
                  message: res.data.message,
                  duration: 500
                });
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    getDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      this.$api.get(
        "user/address/list",
        { id_example: mallid, token_user: isUser },
        res => {
          if (res.data.code == "100") {
            if (res.data.data.length != 0) {
              this.datas = res.data.data;
              this.checked = res.data.data.default;
              this.length = res.data.data.length;
            } else {
              this.nodata = true;
            }
          } else {
            this.$toast({
              message: res.data.message,
              duration: 500
            });
          }
        }
      );
    },
    morenPlay: function(id, index, moren) {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      if (moren != 1) {
        this.$api.post(
          "user/address/setdefault",
          { id_example: mallid, token_user: isUser, id_address: id },
          res => {
            if (res.data.code == "100") {
              $.each(this.datas, function(index, items) {
                items.default = 0;
              });
              this.datas[index].default = 1;
            } else {
              if (res.data.message == "token验证失败") {
                this.$dialog
                  .confirm({
                    title: "提示 ",
                    message: "您还未登录是否去登录？"
                  })
                  .then(() => {
                    this.$router.push({ name: "NoteLogin" });
                  })
                  .catch(() => {});
              } else {
                this.$toast({
                  message: res.data.message,
                  duration: 500
                });
              }
            }
          }
        );
      }
    }
  },
  mounted() {
    this.getDatas();
  }
};
</script>

<style lang="less">
.sitelist {
  min-height: 100vh;
  background-color: #f5f5f5;
  .text-cent {
    display: flex;
    flex-direction: column;
    align-items: center;

    .text {
      margin-top: 0.2rem;
      font-size: 0.24rem;
    }
  }

  .van-checkbox__icon {
    color: #fff;
    border: 0.01rem solid #999;
  }
  .sitebox {
    width: 100%;
    display: flex;

    .site-btnbox {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 1.5rem;

      .icon-size {
        width: 0.4rem;
        height: 0.4rem;
      }

      span {
        margin: 0.1rem 0;
      }
    }

    .sitebox-user {
      width: 100%;

      .van-address-list__name {
        font-size: 0.3rem;
        font-weight: bold;
        color: #262626;
        line-height: 0.42rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .van-address-list__name-all {
          display: flex;
          align-items: center;
        }

        .sitebox-mr {
          width: 0.6rem;
          height: 0.28rem;
          background: #fe5c42;
          border-radius: 0.06rem;
          font-size: 0.2rem;
          font-weight: 500;
          color: #ffffff;
          line-height: 0.28rem;
          padding: 0 0.1rem;
          text-align: center;
          margin-left: 0.1rem;
          position: relative;
          top: 0.02rem;
        }
      }

      .van-address-list__address {
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 0.8);
        line-height: 0.48rem;
      }
    }
  }
  .clearbtn,
  .van-swipe-cell__left {
    width: 1rem;
    height: 100%;
    border: none;
    background-color: #fa4a0f !important;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .site-address {
    padding: 0.1rem 0;
  }
  .addSiteBtn {
    width: 100%;
    position: fixed;
    bottom: 0.5rem;
    left: 0;
    display: flex;
    justify-content: center;

    .add {
      width: 6.3rem;
      height: 0.96rem;
      background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
      border-radius: 0.48rem;
      font-size: 0.3rem;
      color: #ffffff;
      line-height: 0.42rem;
    }
  }
  .popupleft {
    width: 100%;
    height: 100%;
  }
  .van-card {
    margin: 0.15rem 0;
  }
  .van-card,
  .van-cell-group,
  .van-cell {
    background-color: #fff;

    &::after {
      border: none;
    }
  }

  .van-cell-group {
    border-bottom: 0.01rem solid #ebedf0;
  }

  .van-cell:not(:last-child)::after {
    border-bottom-width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/mysite/mysites.vue